import { createSlice } from "@reduxjs/toolkit";

import {
  setStateFailed,
  setStatePending,
} from "@/store/apiRequestStatusMachine";

import { fetchProductLayout } from "./actions";
import type { ProductLayoutData, ProductsState } from "./types";

const getInitialState = (): ProductsState => ({
  productLayout: { status: "idle" },
});

export const productsSlice = createSlice({
  name: "products",
  initialState: getInitialState(),
  reducers: {
    resetProductsSlice: () => {
      return getInitialState();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductLayout.pending, (state) => {
        setStatePending<ProductLayoutData>(
          state.productLayout,
          (nextState) => (state.productLayout = nextState),
        );
      })
      .addCase(fetchProductLayout.fulfilled, (state, { payload }) => {
        state.productLayout = { status: "succeeded", state: payload };
      })
      .addCase(fetchProductLayout.rejected, (state) => {
        setStateFailed<ProductLayoutData>(
          state.productLayout,
          (nextState) => (state.productLayout = nextState),
        );
      });
  },
  selectors: {
    selectProductLayout: (state) => state.productLayout,
  },
});

export const { resetProductsSlice } = productsSlice.actions;

export const { selectProductLayout } = productsSlice.selectors;

export default productsSlice.reducer;
